import { restHeartClient } from '..'

/**
 * 新增文档。
 * @param db
 * @param collection
 * @param data
 */
export function addDocument(db: string, collection: string, data: any) {
	if (typeof data !== 'object') {
		throw new Error('文档数据必须是对象！')
	}
	return restHeartClient.post(`${db}/${collection}`, data)
}
